export default "//cdn.scentbird.com/assets/frontbird-site/images/mobile_64de2b.mp4";